import { render, staticRenderFns } from "./AuditDetails.vue?vue&type=template&id=208e96cd&"
import script from "./AuditDetails.vue?vue&type=script&lang=js&"
export * from "./AuditDetails.vue?vue&type=script&lang=js&"
import style0 from "./AuditDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AuditDetails.vue"
export default component.exports